import { CountryCode } from "./enums";
import type { Mandators, Tenant, BusinessPartner } from "./types";

// This map is to be used for purpose of filtering EPF seriesnodes response.
const countryNamesByCode: Record<CountryCode, string> = {
  [CountryCode.DE]: "Germany",
  [CountryCode.CH]: "Switzerland",
  [CountryCode.ES]: "Spain",
  [CountryCode.GB]: "United Kingdom",
  [CountryCode.CZ]: "Czech Republic",
  [CountryCode.ZA]: "South Africa",
  [CountryCode.AE]: "United Arab Emirates",
  [CountryCode.MY]: "Malaysia",
};

const mandatorsConfig: Mandators = {
  100: {
    countries: [CountryCode.DE, CountryCode.CZ],
  },
  140: {
    countries: [CountryCode.GB],
  },
  240: {
    countries: [CountryCode.ES],
  },
  900: {
    countries: [CountryCode.CH, CountryCode.ZA],
  },
};

const tenantsConfig: Partial<Record<Tenant, BusinessPartner[]>> = {
  // TROX Middle East business partners
  [CountryCode.AE]: [
    CountryCode.DE,
    CountryCode.GB,
    CountryCode.CH,
    CountryCode.ZA,
    CountryCode.CZ,
    CountryCode.ES,
  ],
  // TROX Malaysia business partners
  [CountryCode.MY]: [
    CountryCode.DE,
    CountryCode.CH,
    CountryCode.ES,
    CountryCode.GB,
    CountryCode.CZ,
    CountryCode.MY,
  ],
  [CountryCode.ZA]: [CountryCode.DE, CountryCode.ZA],
};

const mandatorByCountryCode: Record<string, string> = {};

Object.entries(mandatorsConfig).forEach(([key, value]) => {
  const { countries } = value;
  countries.forEach((country) => {
    mandatorByCountryCode[country] = key;
  });
});

export {
  CountryCode,
  countryNamesByCode,
  mandatorsConfig,
  tenantsConfig,
  mandatorByCountryCode,
};
